import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const EmployeeTestimonials = ({ company }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Hear From Our Team
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Real stories from employees who started their journey just like you
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {company?.testimonials?.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-card rounded-2xl p-6 shadow-lg border border-border hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="relative">
                  <Image 
                    src={testimonial?.avatar}
                    alt={testimonial?.avatarAlt}
                    className="w-16 h-16 rounded-full object-cover border-2 border-primary/20"
                  />
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-success rounded-full border-2 border-card flex items-center justify-center">
                    <Icon name="Check" size={12} color="white" />
                  </div>
                </div>
                
                <div className="flex-1">
                  <h4 className="font-semibold text-foreground">{testimonial?.name}</h4>
                  <p className="text-sm text-muted-foreground">{testimonial?.role}</p>
                </div>
              </div>
              
              <div className="flex gap-1 mb-3">
                {[...Array(5)]?.map((_, i) => (
                  <Icon key={i} name="Star" size={16} color="#F59E0B" className="fill-current" />
                ))}
              </div>
              
              <p className="text-muted-foreground leading-relaxed mb-4">
                "{testimonial?.quote}"
              </p>
              
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Calendar" size={14} />
                <span>Joined {testimonial?.joinedDate}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmployeeTestimonials;